import { render, staticRenderFns } from "./CustomerTeamsForm.vue?vue&type=template&id=5e1dfb7a"
import script from "./CustomerTeamsForm.vue?vue&type=script&lang=js"
export * from "./CustomerTeamsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports